<script>

import {symbol_by_code} from "./currencies.js";
import axios from 'axios';

export default {
  name: "product-table-ll",
  props: {
    items: Array,
    cart: Object,
    previousLlLesson: Object,
  },
  data() {
    return {
      discount: false,
      c_symbol: '',
      selectedCountry: null,
      countries: [
        { code: 'CZ', label: 'Česko', vat: 'osvobozeno', vatNote: 'Lekce s lektorem jsou osvobozeny od DPH' },
        { code: 'SK', label: 'Slovensko', vat: '23%', vatNote: 'Lekce s lektorem podléhají DPH 23%' }
      ],
      isUpdatingCountry: false
    }
  },
  mounted() {
    this.c_symbol = symbol_by_code(this.cart.currency_code)
    this.selectedCountry = this.cart.country || 'CZ' // Initialize from cart
    this.initializeItems()
  },
  computed: {
    lectorName() {
      if (!this.previousLlLesson?.lector) return '-'
      return `${this.previousLlLesson.lector.first_name} ${this.previousLlLesson.lector.last_name}`
    },
    lessonMinutes() {
      return this.previousLlLesson?.minutes || 45
    },
    vatInfo() {
      const country = this.countries.find(c => c.code === this.selectedCountry)
      return country ? country.vat : ''
    },
    vatNote() {
      const country = this.countries.find(c => c.code === this.selectedCountry)
      return country ? country.vatNote : ''
    }
  },
  methods:{
    initializeItems(){
      let needsUpdate = false
      
      for(let i in this.items){
        this.items[i].selected_variant = this.items[i].product.id
        let it = this.items[i]
        
        if (it.qty<4){
          this.items[i].qty=4
          needsUpdate = true
        }

        // Always use values from previousLlLesson (existing lesson)
        if (this.previousLlLesson) {
          this.items[i].lector_id = this.previousLlLesson.lector_id
          this.items[i].lesson_minutes = this.previousLlLesson.minutes
          needsUpdate = true
        } else {
          // Fallback for new students (shouldn't happen in normal flow)
          if (!it.lesson_minutes) {
            this.items[i].lesson_minutes = 45
            needsUpdate = true
          }
        }
        
        // If we set any defaults, update the item to refresh price
        if (needsUpdate) {
          this.changeProduct(it)
        }
      }
    },
    zaokrouhleni(c){
      return Math.round(c)
    },
    perioda(m){
      if (m==1) return 'měsíčně'
      if (m==3) return 'čtvrtletně'
      if (m==6) return 'půlročně'
      if (m==12) return 'ročně'
    },
    changeProduct(it){
      this.$emit('changeProduct', it)
    },
    hasSubscription(){
      for(let i in this.items){
        if (this.items[i].months>1){
          return true
        }
      }
      return false
    },
    updateCountry() {
      if (this.isUpdatingCountry) return;
      this.isUpdatingCountry = true;
      
      axios.post('/shopping_cart/update_country', {
        cart_id: this.cart.id,
        country: this.selectedCountry
      })
      .then(response => {
        if (response.data.success) {
          this.$emit('refresh-cart'); // Refresh cart to recalculate prices with new VAT
        }
      })
      .catch(error => {
        console.error('Failed to update country:', error);
        alert('Nepodařilo se změnit zemi. Zkuste to prosím znovu.');
        // Revert to original country
        this.selectedCountry = this.cart.country;
      })
      .finally(() => {
        this.isUpdatingCountry = false;
      });
    }
  },

  watch: {
    cart: {
      handler: function (val) {
        this.c_symbol = symbol_by_code(val.currency_code)
        // Update selectedCountry when cart changes (e.g., after country update)
        if (val.country && val.country !== this.selectedCountry) {
          this.selectedCountry = val.country
        }
      },
      deep: true
    },

    items: {
      handler: function (val) {
        for(let i in this.items){
          this.items[i].selected_variant = this.items[i].product.id
          let it = this.items[i]
          if (it.discounted_price!=it.price_with_tax){
            this.discount = true
          }

          if (it.qty<4){
            this.items[i].qty=4
          }

          // Ensure lector and minutes are always from previousLlLesson
          if (this.previousLlLesson) {
            this.items[i].lector_id = this.previousLlLesson.lector_id
            this.items[i].lesson_minutes = this.previousLlLesson.minutes
          }

        }

        this.cart.get_total_price = parseFloat(this.cart.get_total_price)
        this.cart.get_discounted_price = parseFloat(this.cart.get_discounted_price)
        //console.log('ceny,',this.cart.get_total_price , this.cart.get_discounted_price )
      },
      deep: true
    }
  },
}
</script>

<template>
  <div>
    <div class="cart-info-header">
      <div class="info-section">
        <span class="info-label">Měna:</span>
        <span class="info-value">{{ cart.currency_code }}</span>
      </div>
      <div class="info-section">
        <span class="info-label">Země:</span>
        <select 
          v-model="selectedCountry" 
          @change="updateCountry" 
          class="country-select"
          :disabled="isUpdatingCountry"
        >
          <option v-for="c in countries" :key="c.code" :value="c.code">
            {{ c.label }} (DPH: {{ c.vat }})
          </option>
        </select>
      </div>
      <div class="info-section" v-if="vatNote">
        <small class="text-muted">
          <i class="fas fa-info-circle"></i> {{ vatNote }}
        </small>
      </div>
    </div>
    
  <table class="item table">
    <thead>
    <tr>
      <th>{{ $t('cart.product') }}</th>
      <th>{{ $t('cart.lector') }}</th>
      <th>{{ $t('cart.lesson_count') }}</th>
      <th>{{ $t('cart.lesson_duration') }}</th>
      <th id="right">{{ $t('cart.amount') }}</th>
      <th v-if="hasSubscription()">{{ $t('cart.period') }}</th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="it in items">
      <td>{{ it.product.name }}</td>
      <td>
        <strong>{{ lectorName }}</strong>
      </td>
      <td>
        <select v-model="it.qty" @change="changeProduct(it)" class="form-control">
          <option :value="4">4 {{ $t('cart.lessons') }}</option>
          <option :value="8">8 {{ $t('cart.lessons') }}</option>
          <option :value="10">10 {{ $t('cart.lessons') }}</option>
          <option :value="20">20 {{ $t('cart.lessons') }}</option>
        </select>

      </td>
      <td>
        <strong>{{ lessonMinutes }} {{ $t('cart.minutes') }}</strong>
      </td>
      <td id="right">{{ Math.trunc(it.price_with_tax * it.qty) }} {{c_symbol}}</td>
      <td v-if="hasSubscription()">{{perioda(it.months)}}</td>
    </tr>
    <tr v-if="discount">
      <td> </td>
      <td> Sleva </td>
      <td> </td>
      <td id="right">- {{ zaokrouhleni(cart.get_total_price - cart.get_discounted_price) }} {{c_symbol}}  </td>
      <td v-if="hasSubscription()"> </td>
    </tr>
    </tbody>
    <tfoot v-if="discount">
    <tr id="discount-price">
      <td> </td>
      <td> <b>Cena po slevě</b> </td>
      <td> </td>
      <td id="right"> <b>{{ zaokrouhleni(cart.get_discounted_price) }} {{c_symbol}} </b> </td>
      <td v-if="hasSubscription()"></td>
    </tr>
    </tfoot>
  </table>
  </div>
</template>

<style scoped>

#right {
  text-align: right;
}

.cart-info-header {
  display: flex;
  gap: 24px;
  align-items: center;
  padding: 16px;
  background-color: #f8f9fa;
  border-radius: 8px;
  margin-bottom: 16px;
}

.info-section {
  display: flex;
  align-items: center;
  gap: 8px;
}

.info-label {
  font-weight: 600;
  color: #495057;
}

.info-value {
  font-weight: 500;
  color: #212529;
}

.country-select {
  padding: 6px 12px;
  border: 1px solid #ced4da;
  border-radius: 6px;
  background-color: white;
  font-size: 0.95rem;
  cursor: pointer;
  transition: border-color 0.15s ease-in-out;
}

.country-select:hover:not(:disabled) {
  border-color: #80bdff;
}

.country-select:disabled {
  background-color: #e9ecef;
  cursor: not-allowed;
}

</style>